import React from "react";
import ProductCategory from "../../productcategory2";
import SEO from "../../seo";

export default function ContourSeriesPage() {
  const data = {
    categoryName: "Contour Care Series",
    description:
      "Eclipse Contour Care Series is our range of Bonnell Spring mattresses. Bonnell coil inner springs are universally supportive and built to last. This range is a part of Eclipse International’s original product line and provides comfort solutions that emphasize ideal sleeping posture and is endorsed by chiropractors. Designed to provide great value and offer various levels of comfort, our Contour Care mattresses are tried, trusted and treasured.",
    benefits: [
      "Universally supportive and built to last",
      "Features the oldest and most traditional form of inner spring",
      "Endorsed by chiropractors and emphasizes ideal sleeping postures",
      "Provides great value and offers various levels of comfort",
    ],
    products: [
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Princeton-PT.png",
        name: "PRINCETON PT",
        link: "/contour-series/princeton-pt/",
        startingAt: "₹13,299",
      },
      {
        img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Princeton.png",
        name: "PRINCETON",
        link: "/serene-series/princeton/",
        startingAt: "₹13,299",
      },
    ],
    brochureLink: "https://eclipsemattress.in/assets/pdfs/Eclipse-Catalog.pdf",
    actionToAccess: false,
    banner: "https://eclipsemattress.in/assets/images/banners/contour-d.jpg",
    bannerSm: "https://eclipsemattress.in/assets/images/banners/contour-m.jpg",
  };
  return (
    <div>
      <SEO
        title="Contour Best Spring Mattress | Eclipse International"
        description="Buy the best spring mattress at best prices from contour collection that gives you support and various levels of comfort. Available in different sizes for single bed mattress and double bed mattress"
        img="https://eclipsemattress.in/assets/linkpreviews/category/contour-series.jpg"
      />
      <ProductCategory category={data} />
    </div>
  );
}
